import "bootstrap/js/dist/modal";

class videoFw {
	constructor() {
		this.videoFullwidth();
	}

	videoFullwidth() {
		// Gets the video src from the data-src on each button
		$(document).on('click', '.js-trigger-videomodelar5', function (e) {
            e.preventDefault();
            var elem = $(e.currentTarget);
            var videoID = elem.attr('data-videoID');
            var videoType = elem.attr('data-videoType');
			let videoSrc = '';
			if ( 'vimeo' == videoType ) {
				videoSrc = 'https://player.vimeo.com/video/' + videoID + '?autoplay=1&autopause=1&title=0&byline=0&portrait=0&sidedock=0&controls=1';
			} else {
				videoSrc = 'https://www.youtube.com/embed/' + videoID + '?mute=0&autoplay=1&rel=0&showinfo=1&controls=1&autopause=0';
			}

            $("#videoModal iframe#video").attr(
                "src",
                videoSrc
            );
        });
	
		// stop playing the youtube video when I close the modal
		$("#videoModal").on("hide.bs.modal", function (e) {
			// a poor man's stop video
			$("#video").attr("src", '');
		});
	}
}

export default videoFw;
new videoFw();
